/* global window, document, Tabulator */

(function (window, document) {
    var root = document.getElementById('radar-watchlist-root');
    if (!root) return;

    function qs(sel, el) { return (el || document).querySelector(sel); }
    function setStatus(msg) { var el = qs('[data-radar-status]', root); if (el) el.textContent = msg || ''; }
    function escHtml(s) {
        if (s == null) return '';
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    var apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var client = new window.AppaltiMap.ApiGatewayClient({
        baseUrl: apiBase,
        tokenStore: new window.AppaltiMap.TokenStore('appaltimap_auth')
    });

    function authHeaders() {
        var token = client.tokenStore.getToken() || '';
        var h = { Accept: 'application/json' };
        if (token) h.Authorization = 'Bearer ' + token;
        return h;
    }

    function getJson(url) {
        return fetch(url, { headers: authHeaders() }).then(function (r) { if (!r.ok) throw r; return r.json(); });
    }

    function post(url) {
        return fetch(url, { method: 'POST', headers: authHeaders() }).then(function (r) { if (!r.ok) throw r; return r.json().catch(function () { return {}; }); });
    }

    var table;
    function buildTable() {
        if (typeof Tabulator === 'undefined') { setStatus('Tabulator non disponibile.'); return; }
        var el = qs('#radar-watchlist-table', root);
        if (!el || table) return;
        table = new Tabulator(el, {
            layout: 'fitColumns',
            placeholder: 'Nessun elemento',
            columns: [
                { title: 'Tipo', field: 'item_type', width: 140 },
                { title: 'Chiave', field: 'item_key', minWidth: 200, formatter: function (c) { return '<code>' + escHtml(c.getValue() || '') + '</code>'; } },
                { title: 'Creato', field: 'created_at', width: 200 },
                {
                    title: '',
                    field: '_actions',
                    width: 120,
                    formatter: function () { return '<button type="button" class="appaltimap-btn appaltimap-btn--small" data-action="remove">Rimuovi</button>'; },
                    cellClick: function (e, cell) {
                        var row = cell.getRow().getData();
                        setStatus('Rimozione…');
                        post(apiBase + '/radar/watchlist/remove?' + new URLSearchParams({ item_type: row.item_type, item_key: row.item_key }).toString())
                            .then(load)
                            .catch(function () { setStatus('Impossibile rimuovere.'); });
                    }
                }
            ]
        });
        root._vgTabulator = table;
    }

    function load() {
        buildTable();
        if (!table) return;
        setStatus('Caricamento…');
        return getJson(apiBase + '/radar/watchlist')
            .then(function (data) {
                table.setData((data && data.items) || []);
                setStatus('');
            })
            .catch(function () { setStatus('Impossibile caricare. Assicurati di avere un token pro nel browser.'); });
    }

    function onAdd(e) {
        e.preventDefault();
        var form = qs('[data-radar-add-form]', root);
        if (!form) return;
        var fd = new FormData(form);
        var item_type = String(fd.get('item_type') || '').trim();
        var item_key = String(fd.get('item_key') || '').trim();
        if (!item_type || !item_key) { setStatus('Compila tipo e chiave.'); return; }
        setStatus('Aggiunta…');
        post(apiBase + '/radar/watchlist/add?' + new URLSearchParams({ item_type: item_type, item_key: item_key }).toString())
            .then(load)
            .catch(function () { setStatus('Impossibile aggiungere.'); });
    }

    var addForm = qs('[data-radar-add-form]', root);
    if (addForm) addForm.addEventListener('submit', onAdd);

    load();
})(window, document);

